import { BaseMutations } from '@/store/base-mutations';
import { Staffs, StaffsFilters } from '@/modules/staffs/types';
import CompaniesUsersManagersState from './state';

export default class CompaniesUsersManagersMutations extends BaseMutations<CompaniesUsersManagersState> {
  UPD_FILTER_KEY({
    key,
    value,
  }: {
    key: keyof StaffsFilters | string;
    value: unknown;
  }) {
    this.state.filters[key] = value;
  }

  // receiving and handling data from server

  TOGGLE_LOADING_COMPANIES_USERS_MANAGERS(toggle: boolean) {
    this.state.companies_users_managers_loading = toggle;
  }

  SET_COMPANIES_USERS_MANAGERS(companies_users_managers: Staffs.Staff[]) {
    this.state.companies_users_managers = companies_users_managers;
  }

  SET_COMPANIES_USERS(
    companies_users: Pick<Staffs.Staff, 'id'|'name_company'>[],
  ) {
    this.state.companies_users = companies_users;
  }
}
